/**
 * Array containing supported languages.
 * @type {string[]}
 */
export const languages = ["en", "ka"];
